'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('HubStyleTokens/colors');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HubSubtitle = _styledComponents2.default.div.withConfig({
  displayName: 'HubSubtitle'
})(['color:', ';font-size:14px;line-height:24px;text-align:center;margin-bottom:40px;'], _colors.OBSIDIAN);

exports.default = HubSubtitle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/HubSubtitle.js
// module id = 339
// module chunks = 3 4